import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RouteProtecter from './RouteProtecter';
import Layout from '../components/Layout';
import Login from '../../src/components/Login';
import AddReport from '../components/AddReport';
import OtpVerification from '../components/OtpVerification';
import Patient from '../components/Patient';
import FolderUpload from '../components/fileUpload/FolderUpload';
import UsersReportDone from '../components/UsersReportDone';
import PatientBilling from '../components/patient/PatientBilling';
import PatientRegistration from '../components/patient/PatientRegistration';
import StudyAdd from '../components/patient/StudyAdd';
import AddUser from '../components/createUser/AddUser';
import AgentPanel from '../components/subscription/AgentPanel';
import AdminPanel from '../components/subscription/AdminPanel';
import TurnaroundTimeDashboard from '../components/TurnaroundTime';
import BusinessRevenueDashboard from '../components/BusinessRevenue';
import StudyTransfer from '../components/StudyTransfer';
import UpdateDoctor from '../components/createUser/UpdateDoctor';
import Users from '../components/createUser/Users';
import Verifier from '../components/createUser/Verifier';
import VerifierUser from '../components/createUser/VerifierUser';
import SubscriptionExpired from '../components/SubscriptionExpired';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/patient-verification" element={<OtpVerification />} />
        <Route
          path="/subscription-expired"
          element={
            <RouteProtecter>
              <SubscriptionExpired />
            </RouteProtecter>
          }
        />

        <Route
          path="/view-report"
          element={
            <RouteProtecter>
              <Layout>
                <AddReport />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/add-report"
          element={
            <RouteProtecter>
              <Layout>
                <AddReport />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/update-doctor"
          element={
            <RouteProtecter>
              <Layout>
                <UpdateDoctor />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/create-user"
          element={
            <RouteProtecter>
              <Layout>
                <AddUser />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/verifier"
          element={
            <RouteProtecter>
              <Layout>
                <Verifier />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/add-verifier"
          element={
            <RouteProtecter>
              <Layout>
                <VerifierUser />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/users"
          element={
            <RouteProtecter>
              <Layout>
                <Users />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/report-upload"
          element={
            <RouteProtecter>
              <Layout>
                <FolderUpload />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/report-by-users"
          element={
            <RouteProtecter>
              <Layout>
                <UsersReportDone />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/patient-registration"
          element={
            <RouteProtecter>
              <Layout>
                <PatientRegistration />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/patient-billing"
          element={
            <RouteProtecter>
              <Layout>
                <PatientBilling />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/add-new-study"
          element={
            <RouteProtecter>
              <Layout>
                <StudyAdd />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/turnaround-time"
          element={
            <RouteProtecter>
              <Layout>
                <TurnaroundTimeDashboard />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/business-revenue"
          element={
            <RouteProtecter>
              <Layout>
                <BusinessRevenueDashboard />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/study-transfer"
          element={
            <RouteProtecter>
              <Layout>
                <StudyTransfer />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/subscription-agent"
          element={
            <RouteProtecter>
              <Layout>
                <AgentPanel />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/subscription-admin"
          element={
            <RouteProtecter>
              <Layout>
                <AdminPanel />
              </Layout>
            </RouteProtecter>
          }
        />
        <Route
          path="/patient-report"
          element={
            <Layout>
              <Patient />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
